import ProjectSettingsSection from './ProjectSettingsSection';
import ProjectBriefSection from './ProjectBriefSection';
import ProjectCommercialSection from './ProjectCommercialSection';
import { CaracteristiquesTabContent } from './ProjectSetupSection';

/** ProjectSettingsHub — V17.0 : Identité & calendrier · Demande client · Caractéristiques · Commercial. */
export default function ProjectSettingsHub({ tab, project, projectId, onSaved, onOpen }) {
  return (
    <div data-testid={`settings-${tab}`}>
      {tab === 'identite' && <ProjectSettingsSection project={project} projectId={projectId} onSaved={onSaved} />}
      {tab === 'demande' && <ProjectBriefSection project={project} projectId={projectId} onSaved={onSaved} onOpenFilesTab={() => onOpen('ressources', 'fichiers')} />}
      {tab === 'caracteristiques' && <CaracteristiquesTabContent project={project} projectId={projectId} onProjectSaved={onSaved} />}
      {tab === 'commercial' && <ProjectCommercialSection projectId={projectId} project={project} />}
    </div>
  );
}
